export type TDeviceInfo = {
    device_memory: number
    device_hardware_concurrency: number
}

export const getDeviceInfo = (): TDeviceInfo => {
    const { deviceMemory } = navigator as Navigator & { deviceMemory?: number }

    return {
        device_memory: deviceMemory ?? 0,
        device_hardware_concurrency: navigator.hardwareConcurrency || 0,
    }
}
